module.exports = "<div class=\"login-loader-container\">\n  <div class=\"login-loader\">\n    <div class=\"circle\" [ngClass]=\"circleAnimationClass\"></div>\n    <div class=\"label\">Authenticating{{loadingDots}}</div>\n    <div class=\"content\" i18n=\"@@varificationLoadingMsg\">Please wait, we are verifying your credentials to log you in</div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/new-login/newlogin-loader/newlogin-loader.component.html
// module id = ./src/app/new-login/newlogin-loader/newlogin-loader.component.html
// module chunks = main